











import { Vue, Component, Prop } from 'vue-property-decorator'
import DraftSessionWildRift from '@/modules/draft/components/DraftSessionWildRift'

@Component({
  components: { DraftSessionWildRift }
})
export default class DraftSessionWildRiftView extends Vue {
  @Prop({ type: String, required: true })
  draftSessionId!: string

  @Prop({ type: String, required: true })
  teamNumber!: string

  close() {
    // This is for mobile close webview
    window.location.href = 'https://www.google.com/back'
  }
}
